import React, { createContext, useCallback, useContext, useState } from 'react';
import { Alert, Portal, Snackbar } from '@mui/material';

const ToastContext = createContext(null);

const AUTO_HIDE_DURATION = 4000;
// Above Headless UI cancel dialogs (z-1600) and other modals
const TOAST_Z_INDEX = 10000;

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  const showToast = useCallback((message, severity = 'success') => {
    setToast({ open: true, message, severity });
  }, []);

  const showSuccessToast = useCallback(
    (message) => {
      showToast(message, 'success');
    },
    [showToast],
  );

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return;
    setToast((prev) => ({ ...prev, open: false }));
  };

  return (
    <ToastContext.Provider value={{ showToast, showSuccessToast }}>
      {children}
      <Portal>
        <Snackbar
          open={toast.open}
          autoHideDuration={AUTO_HIDE_DURATION}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          sx={{ zIndex: TOAST_Z_INDEX }}
        >
          <Alert
            onClose={handleClose}
            severity={toast.severity}
            variant="filled"
            sx={{
              width: '100%',
              ...(toast.severity === 'success' && {
                backgroundColor: '#126656',
              }),
            }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      </Portal>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  return (
    context || {
      showToast: () => {},
      showSuccessToast: () => {},
    }
  );
};
